import { useCallback } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Button, IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router';

type AppProps = {
  open: boolean;
  handleClose: () => void;
  handleCloseCreateModal: () => void;
  paymentId: string;
};

const useStyles = makeStyles((theme) => ({
  container: {
    overflow: 'hidden auto',
    width: '100%',
    height: '100%',
    display: 'flex',
    placeContent: 'center',
    placeItems: 'center',
  },
  containerDesktop: {
    paddingTop: '2%',
    paddingBottom: '2%',
  },
  linkBase: {
    margin: 'auto',
    backgroundColor: 'white',
  },
  linkDesktop: {
    overflow: 'hidden',
    minHeight: '800px', // 16:9 ratio
    height: '100%',
    maxHeight: '800px',
    width: '450px',
    minWidth: '450px',
    borderRadius: '8px',
    boxShadow: theme.shadows[5],
  },
  linkMobile: {
    height: '100%',
    width: '100%',
  },
  logo: {
    height: '80px',
    width: '80px',
    margin: 'auto',
  },
}));

export default function CreatePaymentSuccessModal({
  open,
  handleClose,
  handleCloseCreateModal,
  paymentId,
}: AppProps): JSX.Element {
  const isMobile = useCallback((): boolean => {
    return (
      window.matchMedia('(max-width: 760px)').matches &&
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  }, []);
  const isPortrait = window.innerWidth > window.innerHeight ? false : true;
  const classes = useStyles();

  const containerStyle = `${classes.container} ${isMobile() && isPortrait ? '' : classes.containerDesktop}`;
  const linkStyle = `${classes.linkBase} ${isMobile() && isPortrait ? classes.linkMobile : classes.linkDesktop}`;

  const history = useHistory();

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
          handleCloseCreateModal();
        }}
        closeAfterTransition
        hideBackdrop
      >
        <Fade in={open}>
          <Box className={containerStyle}>
            <Box className={linkStyle}>
              <Box style={{ width: '100%', textAlign: 'right' }}>
                <IconButton
                  aria-label="close"
                  onClick={() => {
                    handleClose();
                    handleCloseCreateModal();
                  }}
                  sx={{
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>

              <Avatar className={classes.logo} src="/img/institutions/default.svg" />
              <h1 style={{ width: '100%', textAlign: 'center' }}>Success</h1>

              <Box style={{ width: '100%', textAlign: 'center' }}>
                <CheckCircleIcon className={classes.logo} color="primary" />
              </Box>

              <h2 style={{ textAlign: 'center', margin: '20px' }}>{'Payment has been successfully created'}</h2>
              <p style={{ textAlign: 'center', margin: '20px' }}>
                {'Your payment is now created. You may proceed to see payment details.'}
              </p>

              <Box style={{ width: '100%', textAlign: 'center' }}>
                <Button
                  style={{ width: '80%', margin: 'auto' }}
                  fullWidth={true}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleClose();
                    handleCloseCreateModal();
                    history.push(`/payment/${paymentId}`);
                  }}
                >
                  Continue
                </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
